import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { useInputs } from "hooks/useInputs";
import usePluginEntities from "hooks/usePluginEntities";
const useForwarderInput = (inputId, enabled) => {
  var _a;
  const { fetchForwarderInput } = (_a = usePluginEntities("forwarder")[0]) != null ? _a : {};
  const {
    data: forwarderInput,
    isError,
    isLoading
  } = useQuery({
    queryKey: ["forwarder", "input", inputId],
    queryFn: () => fetchForwarderInput(inputId),
    enabled: !!fetchForwarderInput && enabled
  });
  return isLoading || isError ? void 0 : forwarderInput;
};
const InputField = ({ value }) => {
  var _a, _b, _c;
  const inputsMap = useInputs();
  const forwarderInput = useForwarderInput(value, inputsMap && !inputsMap[value]);
  const inputTitle = (_c = (_b = (_a = inputsMap[value]) == null ? void 0 : _a.title) != null ? _b : forwarderInput == null ? void 0 : forwarderInput.title) != null ? _c : value;
  return /* @__PURE__ */ React.createElement("span", { title: value }, inputTitle);
};
export default InputField;
